import { Box } from '@palmetto/palmetto-components';

import { ProgramType, DomesticContentAttestmentType, AvlFilterOption } from 'types';

import { DomesticContentMountingHardwareSection } from './DomesticContentMountingHardwareSection';
import { EquipmentDetailsFormSection } from './EquipmentDetailsFormSection';
import { MountingHardwareFormSection } from './MountingHardwareFormSection';

interface PVSystemProps {
  programType: ProgramType;
  attestmentType: DomesticContentAttestmentType;
  hideQuantity?: boolean;
  showStorageOptions?: boolean;
  avlFilterOption?: AvlFilterOption;
  allowMultipleInverters?: boolean;
  allowMultipleBatteries?: boolean;
  showOptimizerCheckbox?: boolean;
  showEnphaseCheckboxes?: boolean;
  readOnly?: boolean;
  allowDeleteMountingHardware?: boolean;
  /** Force showing the DC hardware section, instead of inferring whether it should be shown */
  isHardwareOverridden?: boolean;
  hideMountingType?: boolean;
  removeModelWhenManufacturerChanges?: boolean;
  isItcSystemDesignCompleted?: boolean;
  orgAlias?: string;
  isPackageEditable?: boolean;
  useSearchableModelSelect?: boolean;
}

export const PVEquipment = ({
  programType,
  attestmentType,
  hideQuantity,
  showStorageOptions,
  avlFilterOption,
  allowMultipleInverters = true,
  allowMultipleBatteries = false,
  showOptimizerCheckbox = false,
  showEnphaseCheckboxes = false,
  readOnly = false,
  allowDeleteMountingHardware = true,
  isHardwareOverridden = false,
  hideMountingType = false,
  removeModelWhenManufacturerChanges = false,
  isItcSystemDesignCompleted = false,
  orgAlias,
  isPackageEditable = true,
  useSearchableModelSelect = false,
}: PVSystemProps) => {
  const requiresDcHardware =
    avlFilterOption === AvlFilterOption.dcEligibleOnly &&
    attestmentType !== DomesticContentAttestmentType.optOut &&
    attestmentType !== DomesticContentAttestmentType.storageOnly;

  const showDcHardware = isHardwareOverridden || requiresDcHardware;

  return (
    <Box direction="column" gap="lg">
      <EquipmentDetailsFormSection
        hideQuantity={hideQuantity}
        showStorageOptions={showStorageOptions}
        allowMultipleInverters={allowMultipleInverters}
        allowMultipleBatteries={allowMultipleBatteries}
        hideTitleAndDescription
        programType={programType}
        avlFilterOption={avlFilterOption}
        showOptimizerCheckbox={showOptimizerCheckbox}
        showEnphaseCheckboxes={showEnphaseCheckboxes}
        readOnly={readOnly}
        removeModelWhenManufacturerChanges={removeModelWhenManufacturerChanges}
        orgAlias={orgAlias}
        isPackageEditable={isPackageEditable}
        useSearchableModelSelect={useSearchableModelSelect}
      />
      {showDcHardware ? (
        <DomesticContentMountingHardwareSection
          hideTitleAndDescription
          className="border-out"
          programType={programType}
          avlFilterOption={avlFilterOption}
          readOnly={readOnly}
          allowDeleteMountingHardware={allowDeleteMountingHardware}
          hideMountingType={hideMountingType}
          isItcSystemDesignCompleted={isItcSystemDesignCompleted}
          orgAlias={orgAlias}
        />
      ) : (
        <MountingHardwareFormSection
          hideTitleAndDescription
          className="border-out"
          programType={programType}
          avlFilterOption={avlFilterOption}
          readOnly={readOnly}
          hideMountingType={hideMountingType}
          isItcSystemDesignCompleted={isItcSystemDesignCompleted}
          orgAlias={orgAlias}
        />
      )}
    </Box>
  );
};
